import baseURL from './url'; // Asegúrate de importar tu URL base

let usuario = null;

export const fetchUsuario = async () => {
    try {
        const t = await fetch(`${baseURL}/userLogued.php`, { method:'GET' }).then(r=>r.text());
        try { usuario = JSON.parse(t); }
        catch(_) { usuario = null; }
    } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        usuario = null; // Restablecer usuario si hay error
    }
};

export const getUsuario = () => {
    return usuario; // Devuelve los datos del usuario
};
